module.exports = __webpack_public_path__ + "static/img/left-top-row-5.b758f272.png";